import React from 'react';
import Experiment from './Experiment';
import When from '../When';

const isReactElement = element => !!element.type;
const isComponentClass = Comp => Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
const getProps = element => element.props || element.attributes;

const traverseReactTree = (element, visitor) => {
  if (Array.isArray(element)) {
    element.forEach(item => traverseReactTree(item, visitor));
    return;
  }

  if (!element) {
    return;
  }

  if (isReactElement(element)) {
    if (typeof element.type === 'function') {
      const Comp = element.type;
      const props = Object.assign({}, Comp.defaultProps, getProps(element));
      let child;

      if (isComponentClass(Comp)) {
        const instance = new Comp(props);

        if (visitor(element) === false) {
          return;
        }

        child = instance.render();
      } else {
        // a stateless functional
        if (visitor(element) === false) {
          return;
        }

        child = Comp(props);
      }

      if (child) {
        if (Array.isArray(child)) {
          child.forEach(item => traverseReactTree(item, visitor));
        } else {
          traverseReactTree(child, visitor);
        }
      }
    } else {
      // a basic dom element or string
      if (visitor(element) === false) {
        return;
      }

      if (element.props && element.props.children) {
        React.Children.forEach(element.props.children, child => {
          if (child) {
            traverseReactTree(child, visitor);
          }
        });
      }
    }
  } else if (typeof element === 'string' || typeof element === 'number') {
    // Just visit these, they are leaves so we don't keep traversing.
    visitor(element);
  }
};

const getBucketsFromChildren = children => {
  let buckets: string[] = [];
  traverseReactTree(children, el => {
    if (el.type === When) {
      const { bucket } = el.props;
      const addBuckets: string[] = Array.isArray(bucket) ? bucket : [bucket];
      buckets = [...Array.from(new Set(buckets.concat([...addBuckets])))];
      return false;
    }
    return !(el.type === Experiment);
  });
  return buckets;
};

export default getBucketsFromChildren;
